/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { WorkspaceDatabaseKeys } from '@database/workspace';
import { AppVariables } from '@shared';
import { FormControlBase, ITFormControlType } from '../../models';
import { FormControlErrorTypeEnum } from '../../models/form-control-error-type.enum';
import { FormControlTypeEnum } from '../../models/form-control-type.enum';
import { NotSupportedCharactersBuilder } from '../../validations';


@Component({
	selector: 'app-dynamic-form-control',
	templateUrl: './dynamic-form-control.component.html',
	styleUrls: ['./dynamic-form-control.component.scss']
})
export class DynamicFormControlComponent implements OnInit {
	@Input() public dynamicFormControl: FormControlBase<ITFormControlType> | any;
	@Input() public form: UntypedFormGroup;
	@Input() public primaryKeys: string[];

	public formControlType = FormControlTypeEnum;
	public formControlErrorTypes = FormControlErrorTypeEnum;
	public gridFieldSize: number;
	public isDebounceApplied: boolean;

	private isTableIntervalRelated: boolean;
	private isSampleNumberKey: boolean;
	private isPrimaryKey: boolean;
	private fileFieldWidth: number;

	public constructor() {}

	public ngOnInit(): void { 
		if(this.dynamicFormControl.key === "testprcharcol") {
			
			// set UniquePrimaryKeyBuilder not double data with previous data
			console.log(this.dynamicFormControl, "check this");
			console.log(this.isSampleNumberKey, "check this");

			this.primaryKeys = ["testprcharcol"];

		}
		
		this.fileFieldWidth = this.dynamicFormControl.width ?? AppVariables.DEFAULT_FIELD_WIDTH;
		this.gridFieldSize =
			this.fileFieldWidth > AppVariables.LONG_TEXT_LIMIT
				? AppVariables.TEXT_AREA_GRID_SIZE
				: AppVariables.INPUT_GRID_SIZE;
		this.isTableIntervalRelated =
			this.dynamicFormControl.key === WorkspaceDatabaseKeys.columns.depthFrom ||
			this.dynamicFormControl.key === WorkspaceDatabaseKeys.columns.depthTo
				? true
				: false;
		this.isSampleNumberKey = this.dynamicFormControl.key === WorkspaceDatabaseKeys.columns.sampleNumber;
		this.isPrimaryKey = this.primaryKeys.includes(this.dynamicFormControl.key);
		this.isDebounceApplied = this.isTableIntervalRelated || this.isSampleNumberKey || this.isPrimaryKey;

		if (
			['northsouth_decimal', 'eastwest_decimal', 'elevation'].includes(this.dynamicFormControl.key)
		) {
			this.dynamicFormControl.required = true;
			setTimeout(() => {
				this.form.controls[this.dynamicFormControl.key].setValidators([Validators.required]);
				this.form.controls[this.dynamicFormControl.key].updateValueAndValidity(); 
			}, 100);
		}

		
	}
}
